// 📁 components/DotNavigation.jsx
"use client";
import { useFullPageContext } from "@/context/FullPageContext";
import React, { useState } from "react";

interface DotNavigationProps {
  visible: boolean;
}

export default function DotNavigation({ visible }: DotNavigationProps) {
  const { sections, activeIndex, scrollToSection } = useFullPageContext();
  const [hoverIndex, setHoverIndex] = useState<number | null>(null);

  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "20px",
        transform: "translateY(-50%)",
        display: "flex",
        flexDirection: "column",
        gap: "10px", /* Reduced from 14px */
        zIndex: 1000,
      }}
    >
      {sections.map((section, index) => {
        const isActive = activeIndex === index;
        const showLabel = isActive || hoverIndex === index;

        return (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px", /* Reduced from 10px */
              cursor: "pointer",
            }}
            onClick={() => scrollToSection(index)}
            onMouseEnter={() => setHoverIndex(index)}
            onMouseLeave={() => setHoverIndex(null)}
          >
            {/* Dot luôn nằm bên trái */}
            <button
              style={{
                width: isActive ? "10px" : "8px",
                height: isActive ? "10px" : "8px",
                borderRadius: "50%",
                border: "1px solid #1a4d33",
                backgroundColor: isActive ? "#1a4d33" : "transparent",
                transition: "all 0.3s ease",
                cursor: "pointer",
                padding: 0,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#1a4d33";
                e.currentTarget.style.transform = "scale(1.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = isActive
                  ? "#1a4d33"
                  : "transparent";
                e.currentTarget.style.transform = "scale(1)";
              }}
            />

            {/* Label nằm bên phải */}
            <div
              style={{
                color: "#1a4d33",
                padding: "2px 8px",
                borderRadius: "6px",
                fontSize: "12px",
                fontWeight: 600,
                whiteSpace: "nowrap",
                opacity: showLabel ? 1 : 0,
                transform: showLabel ? "translateX(0)" : "translateX(-10px)",
                transition: "opacity 0.3s ease, transform 0.3s ease",
                pointerEvents: showLabel ? "auto" : "none",
              }}
            >
              {section.label}
            </div>
          </div>
        );
      })}
    </div>
  );
}
